<template>
  <div class="animate__animated animate__fadeInUp">
    <div class="titulo">
      <h2>{{dataTextosInicialesNarradores.titulo_narradores}}</h2>
    </div>
    <p v-html="dataTextosInicialesNarradores.texto_narradores">
    </p>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data() {
    return {
      dataTextosInicialesNarradores: null,
      
    }
  },
  async mounted() {
  // TEXTOS ADICIONALES
    await axios
    .get(''+this.$store.state.rutaApi+'textos-iniciales')
    .then(response => (this.dataTextosInicialesNarradores = response.data[0]))
    //  console.log( "dataTextosInicialesNarradores ",this.dataTextosInicialesNarradores)

  },
}
</script>
<style lang="scss" scoped>
.titulo{
  margin-bottom: 20px;
  h2{
    font-size: 1.4em;
    line-height: 1em;
  }
}

</style>
